import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import type {
  ProfitAndLossReportParams,
  ProfitAndLossReportResponse,
} from '@/types';

import { HttpClient } from '@/network/HttpClient';

export const profitAndLossReportKeys = {
  all: () => ['profitAndLossReport'] as const,
  report: (params: ProfitAndLossReportParams) =>
    [
      ...profitAndLossReportKeys.all(),
      params.url,
      params.period,
      params.location,
      params.businessDirection,
      params.breakdown,
    ] as const,
};

export const profitAndLossReportQueries = {
  report: (params: ProfitAndLossReportParams) =>
    queryOptions({
      queryKey: profitAndLossReportKeys.report(params),
      queryFn: () =>
        HttpClient.request<ProfitAndLossReportResponse>({
          method: 'GET',
          url: params.url,
          params: {
            filters: {
              period: params.period,
              // An empty list would reach SQL as `IN (NULL)` and zero the whole
              // report — no filter at all is what an empty picker means.
              ...(params.location.length ? { location: params.location } : {}),
              ...(params.businessDirection.length
                ? { business_direction: params.businessDirection }
                : {}),
            },
            ...(params.breakdown === 'none'
              ? {}
              : { breakdown: params.breakdown }),
          },
        }),
      enabled: !!params.period.from && !!params.period.till,
      retry: false,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),
};
